import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import tableGraphicManagerManifestContent from './tableGraphicManagerManifestContent';

export default {
  title: 'Team content',
  attributeName: 'teamContentResource',
  fields:[
    {
      attributeName: 'short',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Short name',
      label: 'Short name',
      required: true,
      helpText: 'Short name of the team',
      errorText: '',
      enabledWhen:{"field":"modeForm","values":['new']}
    },
    {
      attributeName: 'name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Name',
      label: 'Name',
      required: true,
      helpText: 'Name of the team',
      errorText: '',
    },
    {
      attributeName: 'info',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Extra info',
      label: 'Extra info',
      required: true,
      helpText: 'Extra info of the team',
      errorText: '',
    },
    {
      attributeName: 'logo',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Logo',
      helpText: 'Any valid url to a content file to use inside the main module.',
      hasSelect:false,
      placeholder: 'Logo of the team',
      fileType: ['.jpg', '.jpeg', '.png'],
    },
  ],
 
};
